
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#EA7570","d":"M22.25 26a2.25 2.25 0 002.25-2.25V7.25A2.25 2.25 0 0022.25 5H20V2.563A.564.564 0 0019.437 2h-.375a.564.564 0 00-.562.563V5h-9V2.563A.564.564 0 008.937 2h-.375A.564.564 0 008 2.563V5H5.75A2.25 2.25 0 003.5 7.25v16.5A2.25 2.25 0 005.75 26h16.5zM23 9.5H5V7.25c0-.412.338-.75.75-.75h16.5c.412 0 .75.338.75.75V9.5zm-.75 15H5.75a.752.752 0 01-.75-.75V11h18v12.75c0 .412-.338.75-.75.75zm-5.203-3.431l.267-.267a.563.563 0 000-.797l-2.255-2.255 2.26-2.26a.563.563 0 000-.796l-.267-.267a.563.563 0 00-.797 0L14 16.68l-2.255-2.254a.563.563 0 00-.797 0l-.267.267a.563.563 0 000 .797l2.255 2.254L10.68 20a.563.563 0 000 .797l.267.267c.22.22.577.22.797 0L14 18.81l2.25 2.26c.22.22.577.22.797 0z"}})])
          )
        }
      }
    